import { CanDeactivateFn } from '@angular/router';
import { RecordingComponent } from './recording.component';

export const recordingCanDeactivateGuard: CanDeactivateFn<RecordingComponent> = (component) =>
  component.confirmLeaveRecordingRoute();
